import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  width: 100vw;
`;

export const DatePickerContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  align-items: center;
  max-with: 520px;

  .react-datepicker__header {
    background: #585e66;
  }

  .react-datepicker__current-month {
    color: #40e5a0;
  }
  .react-datepicker-time__header {
    color: #40e5a0;
  }
  .react-datepicker__day {
    font-weight: 600;
    line-height: 2.5rem;
  }
  .react-datepicker__day-name {
    color: #fff;
  }
  .react-datepicker__day--disabled {
    color: gray;
  }
  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
  }

  .react-datepicker__time-container {
    .react-datepicker__time
      .react-datepicker__time-box
      ul.react-datepicker__time-list {
      height: 330px;
      max-height: 350px;

      ::-webkit-scrollbar {
        width: 4px;
      }

      ::-webkit-scrollbar-track {
        background: #eff1f5;
      }

      ::-webkit-scrollbar-thumb {
        background-color: #a9aeb4;
        border-radius: 20px;
        border: none;
      }

      li.react-datepicker__time-list-item {
        font-weight: 600;
      }
    }
  }
`;
export const Content = styled.div`
  display: flex;
  justify-content: center;
  background: #40e5a0;
  border-radius: 8px;
  width: 500px;
`;

export const Label = styled.span`
  font-weight: 600;
  border-radius: 4px;
  background: #40e5a0;
  padding: 1rem;
  text-align: center;
  color: #111;
  font-size: 1.5rem;
`;

export const Text = styled.span`
  font-weight: 600;
  padding: 1rem;
  text-align: center;
  color: #40e5a0;
  font-size: 1.3rem;
`;

export const CustomButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 1rem 2rem;
  background: #585e66;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 4px;
  &:hover {
    filter: brightness(0.8);
  }
`;
